export const disposalProject = {
    panels: [
        {
            index: 0,
            paperType: "A5",
            height: 210,
            width: 148,
            paperHeader: 588,
            paperFooter: 582,
            printElements: [
                {
                    options: {
                        left: 93,
                        top: 6,
                        height: 25.5,
                        width: 265.5,
                        fontSize: 18.75,
                        textAlign: "center",
                        textContentVerticalAlign: "middle",
                        field: "clinicPrescriptionName"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 16.5,
                        height: 16.5,
                        width: 67.5,
                        fontSize: 9,
                        textContentVerticalAlign: "middle",
                        field: "isGrowUp"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 36,
                        height: 19.5,
                        width: 141,
                        title: "健康ID",
                        textContentVerticalAlign: "middle",
                        field: "patId",
                        fontSize: 11.25
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 61.5,
                        height: 19.5,
                        width: 141,
                        title: "费别",
                        field: "prhCostType",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 277.5,
                        top: 61.5,
                        height: 19.5,
                        width: 126,
                        title: "编号",
                        field: "code",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 160.5,
                        top: 61.5,
                        height: 19.5,
                        width: 117,
                        title: "门诊号",
                        field: "seedoctorId",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 87,
                        height: 21,
                        width: 141,
                        title: "姓名",
                        field: "name",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 160.5,
                        top: 87,
                        height: 21,
                        width: 117,
                        title: "年龄",
                        field: "age",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 277.5,
                        top: 87,
                        height: 21,
                        width: 126,
                        title: "性别",
                        field: "sex",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 160.5,
                        top: 112.5,
                        height: 19.5,
                        width: 243,
                        title: "日期",
                        field: "date",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 112.5,
                        height: 19.5,
                        width: 141,
                        title: "科室",
                        field: "dept",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 136.5,
                        height: 18,
                        width: 384,
                        title: "住址",
                        field: "address",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: -1.5,
                        top: 156,
                        height: 9,
                        width: 421.5,
                        borderWidth: "1.5"
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 159,
                        height: 19.5,
                        width: 384,
                        title: "临床诊断",
                        field: "westernDiagnos",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 180,
                        height: 19.5,
                        width: 384,
                        title: "备注",
                        field: "remake",
                        fontSize: 12.75,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: -1.5,
                        top: 201,
                        height: 9,
                        width: 421.5,
                        borderWidth: "1.5"
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 21,
                        top: 213,
                        height: 16.5,
                        width: 61.5,
                        title: "检查项目",
                        fontSize: 12.75
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 204,
                        top: 213,
                        height: 16.5,
                        width: 40.5,
                        title: "数量",
                        fontSize: 12.75
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 259.5,
                        top: 213,
                        height: 16.5,
                        width: 78,
                        title: "执行科室",
                        fontSize: 12.75
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 145.5,
                        top: 213,
                        height: 16.5,
                        width: 45,
                        title: "单位",
                        fontSize: 12.75
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 355.5,
                        top: 213,
                        height: 16.5,
                        width: 55.5,
                        title: "金额",
                        fontSize: 12.75
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 0,
                        top: 235.5,
                        height: 9,
                        width: 420,
                        borderWidth: "1.5",
                        borderStyle: "solid"
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 28.5,
                        top: 245, // 调整为横线下方约10px的位置
                        height: 400,
                        width: 531,
                        field: "disposalProjects",
                    },
                    printElementType: { type: "text" }
                },
                {
                    options: {
                        left: 277.5,
                        top: 499.5,
                        height: 18,
                        width: 120,
                        title: "医师",
                        field: "doctor",
                        fontSize: 9,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: -24,
                        top: 525,
                        height: 9,
                        width: 532.5,
                        borderStyle: "dotted"
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 22.5,
                        top: 529.5,
                        height: 18,
                        width: 120,
                        title: "审核医师",
                        fontSize: 9,
                        textContentVerticalAlign: "middle",
                        field: "doctor"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 277.5,
                        top: 529.5,
                        height: 18,
                        width: 120,
                        title: "核对、发药医师",
                        fontSize: 9,
                        textContentVerticalAlign: "middle",
                        field: "doctor"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 150,
                        top: 529.5,
                        height: 18,
                        width: 120,
                        title: "调配医师/士",
                        fontSize: 9,
                        textContentVerticalAlign: "middle",
                        field: "doctor"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 22.5,
                        top: 552,
                        height: 18,
                        width: 120,
                        title: "处方金额",
                        field: "prescriptionAmount",
                        fontSize: 9,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 277.5,
                        top: 552,
                        height: 18,
                        width: 120,
                        title: "取药科室",
                        field: "phayId",
                        fontSize: 9,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                }
            ],
            paperNumberLeft: 390,
            paperNumberTop: 615,
            rotate: true
        }
    ]
};